import { Injectable, inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { KycAuthService } from './kyc-auth.service';

@Injectable()
export class KycTokenInterceptor implements HttpInterceptor {
  private kycAuthService = inject(KycAuthService);
  private router = inject(Router);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this.router.url.includes('/kyc')) {
      return next.handle(request);
    }

    const token = this.kycAuthService.getToken();
    const isProfileUrl = request.url.includes('/accounts/profile');
    const isKycUrl = request.url.includes('/accounts/kyc/');

    if ((isProfileUrl || isKycUrl) && token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }
    return next.handle(request);
  }
}
